module.exports = __webpack_public_path__ + "images/b91d38b66a07ef1d866bf84a7fb316cc-living_tv.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/living_tv.jpg
// module id = ./src/assets/images/content/living_tv.jpg
// module chunks = 0